import React, {useState} from "react";


//import { Autoplay, A11y} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import SwiperCore, {Pagination} from 'swiper';


import woman from '../../../img/landing/woman.svg'
import man from '../../../img/landing/man.svg'
import Quote from '../../../img/landing/quote.svg'

SwiperCore.use([Pagination]);

import './view3.scss'



import fasting from '../../../img/landing/fasting.png'
import weightLoss from '../../../img/landing/weight-loss.png'
import weightGain from '../../../img/landing/weight-gain.png'
import weightStabilization from '../../../img/landing/weight-stabilization.png'
import ketogenic from '../../../img/landing/ketogenic.png'
import {Button} from "rsuite";





const View3 =(props) =>{
    const pageType = props.pageType ?? null;
    const [swiper, setSwiper] = useState(null)
    const [activeIndex, setActiveIndex] = useState(0);

    const handleSlideClick = (index) => {
        swiper.slideTo(index);
        setActiveIndex(index);
    };

    const updateActiveIndex = () => {
        if (swiper) {
            setActiveIndex(swiper.activeIndex);
        }
    };


    const items=[
 {
            'type':'card',
            'image':fasting,
            'title':'فستینگ',
            'button':{
                'text':'دریافت برنامه',
                'disabled':false
            },

        },       
        {
            'type':'card',
            'image':weightLoss,
            'title':'کاهش وزن',
            'button':{
                'text':'دریافت برنامه',
                'disabled':false
            },
       },

        {
            'type':'card',
            'image':weightGain,
            'title':'افزایش وزن',
            'button':{
                'text':'دریافت برنامه',
                'disabled':false
            },
        },
        {
            'type':'card',
            'image':weightStabilization,
            'title':'تثبیت وزن',
            'button':{
                'text':'دریافت برنامه',
                'disabled':false
            },

        },
        {
            'type':'card',
            'image':ketogenic,
            'title':'کتوژنیک',
            'button':{
                'text':'دریافت برنامه',
                'disabled':true
            },
            'badge':{
                'text':'به زودی',
                'color':'rgba(254, 105, 112, 1)'
            }
        },
        



    ]

    const handleNext = () => {
        window.location.href = '/new-form'
    }

    return (<>
        <div className={`view3-container items-center mb-4 pt-8`}>
            <div className={`${pageType}-title text-medium text-bolder mb-4`}>انواع رژیم‌های  چنگال</div>
            <div className={'bottom-border-orange-green'}  />

            <div className={'slide-container mb-4'}>
                <Swiper
                    slidesPerView={2.1}
                    breakpoints={{
                        768: {
                            slidesPerView: 5,
                        },
                    }}
                    onSwiper={setSwiper}
                    onSlideChange={updateActiveIndex}
                    spaceBetween={.5}
                    pagination={{
                        clickable: true,
                    }}
                    //centeredSlides={true}
                >
                    {items.map((item, index) => (
                        <SwiperSlide key={index}>

                            <div className={` mb-10 w-30   select-none`}>
                                <div className={`card-container `}>
                                   <img
                                       src={item.image}
                                       alt={`slide-${index + 1}`}
                                       className={`card-image`}

                                   />

                                   <div className={'card-body'}>

                                      <div className='card-body-content'>
                                          <div className={`card-title`}>{item.title}</div>

                                          {item?.badge && (
                                              <div className={'card-badge'}>
                                                {item.badge.text }
                                              </div>
                                          )}
                                      </div>

                                       <Button appearance={'ghost'}
                                               loading={false}
                                               onClick={handleNext}
                                               className={`${pageType}-text-small ${pageType}-btn card-button ${item.button.disabled ?'card-button-disabled':'' }`}
                                               disabled={item.button.disabled}
                                               block>
                                           {item.button.text}
                                       </Button>
                                   </div>


                            </div>
                            </div>
                        </SwiperSlide>

                    ))}
                </Swiper>
            </div>
        </div>

    </>)
}
export default View3;
